import { render, staticRenderFns } from "./TheCookieBanner.vue?vue&type=template&id=ca8bed06&scoped=true&"
import script from "./TheCookieBanner.vue?vue&type=script&lang=js&"
export * from "./TheCookieBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheCookieBanner.vue?vue&type=style&index=0&id=ca8bed06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8bed06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VBtn,VSheet})
